import { SvgIcon } from "@material-ui/core";
import { SvgIconProps } from "@material-ui/core/SvgIcon/SvgIcon";
import React from "react";
import pure from "recompose/pure";

const CheckboxCheckedIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 15 15" fill="none"  >
    <path d="M12 1C12 0.4 11.6 0 11 0H1C0.4 0 0 0.4 0 1V11C0 11.6 0.4 12 1 12H11C11.6 12 12 11.6 12 11V1ZM10.3 10.3H1.7V1.7H10.3V10.3ZM15 6V14C15 14.6 14.6 15 14 15H6C5.4 15 5 14.6 5 14V13H13V5H14C14.6 5 15 5.4 15 6ZM5 9.1L2.4 6.6C2.1 6.3 2.1 5.8 2.4 5.5C2.7 5.2 3.2 5.2 3.5 5.5L5 6.9L8.4 3.5C8.7 3.2 9.2 3.2 9.5 3.5C9.8 3.8 9.8 4.3 9.5 4.6L5 9.1Z" fill="#2B3940"/>
  </SvgIcon>
);
CheckboxCheckedIcon.displayName = "CheckboxChecked";
CheckboxCheckedIcon.muiName = "SvgIcon";

export default pure(CheckboxCheckedIcon);